import { Component, OnInit } from '@angular/core';
import { Redlining } from 'src/app/core/models/classes/redlining';
import { RedliningService } from 'src/app/core/services/redlining.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  userName:string;
  style:string;
  filteredRedlinings: number;
  redlinings:Redlining[]=[];
  constructor(private redliningService: RedliningService) {}

  ngOnInit(): void {
    this.userName = localStorage.getItem("name");
    this.redliningService.getRedlinings().subscribe({
      next: (red) => {
        this.redlinings = red;     
        this.filteredRedlinings = this.redlinings.filter(x => x.status === 'New').length;                        
      },
      error: (err) => {
        throw Error(err);
      },
    });
  }

  onRouterLinkAction(event:any){
    if(event===true){
      window.document.getElementById('dash').className='not-active';
    }
    else{
      window.document.getElementById('dash').className='active';
    }
  }
}